<template>
    <button @click="toggleMenu" :class="['burger-button', 'is-' + color, menu && menu.isOpen && 'is-open']" aria-label="Call to action toggle menu">
        <span class="paper boxing"></span>
        <span class="composite">
            <span class="salad layer">
                <span class="sand"/>
                <span class="tomato-sauce"/>
            </span>
            <span class="tofu layer">
                <span class="sand"/>
                <span class="tomato-sauce"/>
            </span>
        </span>
    </button>
</template>
<script>
import {menu} from '@/store/index.js'
export default {
    props: {
        color: {
            type: String,
            default: 'grey',
            validator: function (direction) {
                return ['grey', 'white', 'red'].indexOf(direction) > -1
            }
        }
    },
    data() {
        return {
            menu
        }
    },
    methods: {
        toggleMenu() {
            this.menu.isOpen = !this.menu.isOpen
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.burger-button
    display: inline-flex
    width: 75px
    height: 75px
    border: 1px solid #ffffff
    margin-left: 4px
    position: relative
    justify-content: center
    align-items: center
    flex-direction: column
    cursor: pointer
    overflow: hidden
    pointer-events: all
    @include media-breakpoint-down($sm)
        width: 38px
        height: 38px
    @media print
        display: none
    .boxing
        position: absolute
        width: 100%
        height: 100%
        left: 0
        top: 0
        background-color: #ffffff
        transform: translateY(100%)
        transition: transform 0.5s cubic-bezier(.65,0,.25,1) .3s
        .slim &
            transform: translateY(0%)
    .composite
        display: block
        transition: transform 0.5s
        will-change: transform
    .layer
        width: 30px
        height: 2px
        position: absolute
        top: 50%
        left: 50%
        @include media-breakpoint-down($sm)
            width: 15px
            height: 1px
        &.salad
            // background-color: #636772
            // background-color: #ffffff
            transform: translateX(-50%) translateY(-4px)
            transition: transform 0.5s .5s
            will-change: transform
            overflow: hidden
            @include media-breakpoint-down($sm)
                transform: translateX(-50%) translateY(-2px)
        &.tofu
            // background-color: #636772
            // background-color: #ffffff
            transform: translateX(-50%) translateY(4px)
            transition: transform 0.5s .5s
            will-change: transform
            overflow: hidden
            @include media-breakpoint-down($sm)
                transform: translateX(-50%) translateY(2px)
            .tomato-sauce
                transition: transform 0.3s .5625s
        .sand
            width: 100%
            height: 100%
            background-color: #ffffff
            display: block
            transition: transform 0.3s .5s
            will-change: transform
            transform: translateX(0%)
            position: absolute
            left: 0
            top: 0
        .tomato-sauce
            width: 100%
            height: 100%
            background-color: rgb(255, 43, 43)
            display: block
            transition: transform 0.3s .5s
            will-change: transform
            transform: translateX(-100%)
            position: absolute
            left: 0
            top: 0

    &.is-open
        .composite
            transform: rotate(-45deg)
        .boxing
            transform: translateY(0%)
            transition: transform 0.5s cubic-bezier(.65,0,.25,1) 0.3s
        .layer
            &.salad,
            &.tofu
                transition: transform 0.3s
                transform: translateX(-50%) translateY(0px)
            .sand
                transition: transform 0.5s 0.5s
                transform: translateX(100%)
            .tomato-sauce
                transition: transform 0.5s 0.5s
                transform: translateX(0%)
    &.is-grey
        border: 1px solid rgba(99, 103, 114, 0.15)
        .sand
            background: #636772
    @media not all and (pointer: coarse)
        &:hover
            .boxing
                transform: translateY(0%)
                transition: transform 0.5s cubic-bezier(.65,0,.25,1) 0.3s
            .salad,
            .tofu
                transition: transform 0.5s
                transform: translateX(-50%) translateY(0px)
            .sand
                transition: transform 0.5s 0.5s
                transform: translateX(100%)
            .tomato-sauce
                transition: transform 0.5s 0.5s
                transform: translateX(0%)

</style>
